<template>
</template>

<script>
import { downloadimg } from '@/api/setUp.js'

export default {
  async created () {
    let id = this.$route.query.id
    let { data } = await downloadimg(id)
    let aLink = document.createElement("a");
    aLink.style.display = "none";
    aLink.href = data;
    aLink.download = this.$route.query.imgName;
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink);
  }

}
</script>

<style>
</style>